import React from 'react';
import { AccordionLayout } from '../Activity/AssociationsLayout';
import copyEntityIcon from 'v2/icons/copyEntityIcon.svg';
import { TranslationKeys, PostProcessKeys } from 'translations';
import { useTranslation } from 'react-i18next';
import styles from './linkEntity.module.scss';

const AccordionEntityContent = () => {
  const { t } = useTranslation();

  const dataProviderTranslation = t(TranslationKeys.dataProvider_one, {
    postProcess: PostProcessKeys.TitleCase,
  });

  const contactTranslation = t(TranslationKeys.contact_one, {
    postProcess: PostProcessKeys.TitleCase,
  });

  const datasetTranslation = t(TranslationKeys.dataProduct_one, {
    postProcess: PostProcessKeys.TitleCase,
  });

  const renderContent = () => (
    <div className={styles.content}>
      An entity is a {contactTranslation}, {dataProviderTranslation}, or{' '}
      {datasetTranslation}. When you link it to a request, you are associating
      it with that request and keeping a record of that association. In order to
      link an entity, you will first have to navigate to the entity page and
      click this icon <img src={copyEntityIcon} alt="copyIcon" /> next to the
      entity name to copy its location. You can then paste the entity location
      above.
    </div>
  );

  return (
    <AccordionLayout
      header={'What is an entity and how do I link it?'}
      customStyle={styles}
      content={renderContent()}
    />
  );
};

export default AccordionEntityContent;
